import { NgModule } from '@angular/core';
import { AddButtonModule } from './add-button/add-button.module';
import { EditButtonModule } from './edit-button/edit-button.module';
import { DeleteButtonModule } from './delete-button/delete-button.module';

@NgModule({
  imports: [
    AddButtonModule,
    EditButtonModule,
    DeleteButtonModule
  ],
  exports: [
    AddButtonModule,
    EditButtonModule,
    DeleteButtonModule
  ]
})
export class SharedButtonsModule { }
